import {useMutation, useQuery, useQueryClient} from "react-query";
import {CoinAccount} from "../../typing";
import {http} from "@firefly/fly-http";
import {useInfiniteListQuery} from "../../hook/useInfiniteListQuery";
import {CoinAccountTransfer} from "../../typing/coin";


export function useCoinAccountQuery(uid: string | undefined, key: string) {

    return useQuery<CoinAccount>({
        enabled: !!uid,
        queryKey: ['viewer', uid, 'coin-account', key],
        queryFn: (variables) => {
            if (!key) {
                return Promise.reject('key is required');
            }
            return http.get(`/api/wangame/viewer/coin-account/${key}`, variables)
        },
    })
}


export function useCoinAccountTransferQuery(key: string) {
    return useInfiniteListQuery<CoinAccountTransfer>(['viewer', 'coin-account', key, 'transfer'],
      () => {
      return http.get(`/api/wangame/viewer/coin-account/${key}/transfers`)
    })
}

export interface RechargeGameInput {
    serverId: string;
    amount: number;
}
export function useCoinAccountRechargeGameMutation(key: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (variables: RechargeGameInput) => {
            return http.post(`/api/wangame/viewer/coin-account/${key}/recharge-game`, {
                serverId: variables.serverId,
                amount: variables.amount
            })
        },
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: ['viewer', 'coin-account']
            }).then();
        }
    })
}